import { render } from "./PDFViewer.vue?vue&type=template&id=69c1d248&scoped=true"
import script from "./PDFViewer.vue?vue&type=script&lang=js"
export * from "./PDFViewer.vue?vue&type=script&lang=js"

import "@/assets/css/components/PDFViewer.scss?vue&type=style&index=0&id=69c1d248&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c1d248"]])

export default __exports__